<template>
	<div class="import-log">
		<platformTab @change="handleClick" :showAll="false" :platformId="platformId"></platformTab>
		<div v-show="showPlatformContent">
			<multi-table ref="multiTable" :page="pageInfo" :list="list" :columns="columns" @gePartnerList="gePartnerPage" :total="total"></multi-table>
		</div>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { getTalentExportList, exportAddFail } from '@/api/talentCRM';
import { platformMixin } from '@rd/rd-ui';
import { mapGetters } from 'vuex';
import { columns } from './columns';
export default {
	name: 'importLog',
	components: {},
	mixins: [platformMixin],
	data() {
		return {
			list: [],
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			platformId: '',
			total: 0,
			columns,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
	},
	created() {
		const _platform_id = +this.$route.query.platform_id;
		this.platformId = _platform_id ? _platform_id : this.defaultPlatform;
		this.pageInfo.platform_id = this.platformId;
		this.getList();
	},
	methods: {
		gePartnerPage(val) {
			const { page_index, page_size } = val;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.pageInfo.platform_id = this.platformId;
			this.pageInfo.page_index = 1;
			this.getList();
		},
		async getList() {
			const { code, data: { list = [], page = {} } = {} } = await getTalentExportList(this.pageInfo);
			if (code !== 0) return;
			this.list = list.map(item => {
				return {
					...item,
					operations: this.getButtons(item),
				};
			});
			this.total = page.item_total;
		},
		getButtons(item) {
			const arr = [];
			arr.push({
				label: '导出失败数据',
				type: 'text',
				classtype: 2,
				isShow: (item.task_status == 2 || item.task_status == 3) && item.fail_count,
				click: row => this.exportAddFail(row.fail_id),
			});
			return arr.filter(v => v.isShow);
		},
		exportAddFail: throttle(async function (fail_id) {
			const { download_url } = await exportAddFail({ fail_id });
			window.open(download_url, '_blank');
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
.import-log {
	.tag {
		display: flex;
		align-items: center;
		&::before {
			content: '';
			width: 6px;
			height: 6px;
			border-radius: 50%;
			margin-right: 8px;
		}
		&.error-tag::before {
			background-color: #f03525;
		}
		&.loading-tag::before {
			background-color: #ff8b00;
		}
		&.success-tag::before {
			background-color: #00c840;
		}
	}
}
</style>
